import { Injectable, Input } from '@angular/core';
import { IDashboardSection } from '../dashboard.component';
import { IDashboardMetadata } from '../dashboard-metadata.service';
import { IObject } from '../../../../../type_definitions/datatypes';

@Injectable()
export abstract class BaseDashboardHeaderComponent {
  @Input() public sections:IDashboardSection[];
  @Input() public filters:IObject;
  @Input() public loading:boolean;
  @Input() public dashboardMetadata:IDashboardMetadata;
}